import React from "react";

const ListAndDonar = () => {
  return (
    
      <>
        <div className="container">
            <div className="mt-5 mb-5" style={{border:'1px solid lightgray', padding:'2rem'}}>
          <div className="row">
            <div className="col-md-12">
              <ul>
                <li className="footerLi">Sh. S.K. Dhawan</li>
                <li className="footerLi">Smt. Rita Dhawan</li>
                <li className="footerLi">Sh. Vishwanath</li>
                <li className="footerLi">Sh. Sunil Kumar</li>
                <li className="footerLi">M/s. BVM Meditech P. Ltd.</li>
                <li className="footerLi">M/s. SDR Enterprise</li>
                <li className="footerLi">M/s. Magpie Computers</li>
                <li className="footerLi">Sh. Vivek Bajaj</li>
                <li className="footerLi">M/s. Garg Paints & Sanitary Store, Dilshad Garden, Delhi</li>
              </ul>
            </div>
          </div>
          </div>

        </div>
      </>
  );
};

export default ListAndDonar;
